var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClariaBlackLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.8C0 2.14903 2.14904 0 4.8 0H19.2C21.851 0 24 2.14903 24 4.8V19.2C24 21.851 21.851 24 19.2 24H4.8C2.14904 24 0 21.851 0 19.2V4.8Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0015 4.43492L14.0532 5.55931C14.3225 5.84827 14.7058 6.00749 15.1009 5.99373L16.6401 5.94263C17.4342 5.91511 18.0829 6.56576 18.0574 7.35991L18.0063 8.89907C17.9925 9.29418 18.1517 9.6775 18.4407 9.9468L19.5651 10.9985C20.145 11.541 20.145 12.459 19.5651 13.0015L18.4407 14.0532C18.1517 14.3225 17.9925 14.7058 18.0063 15.1009L18.0574 16.6401C18.0849 17.4342 17.4342 18.0829 16.6401 18.0574L15.1009 18.0063C14.7058 17.9925 14.3225 18.1517 14.0532 18.4407L13.0015 19.5651C12.459 20.145 11.541 20.145 10.9985 19.5651L9.9468 18.4407C9.6775 18.1517 9.29418 17.9925 8.89907 18.0063L7.35991 18.0574C6.56576 18.0849 5.91707 17.4342 5.94263 16.6401L5.99373 15.1009C6.00749 14.7058 5.84827 14.3225 5.55931 14.0532L4.43492 13.0015C3.85503 12.459 3.85503 11.541 4.43492 10.9985L5.55931 9.9468C5.84827 9.6775 6.00749 9.29418 5.99373 8.89907L5.94263 7.35991C5.91511 6.56576 6.56576 5.91707 7.35991 5.94263L8.89907 5.99373C9.29418 6.00749 9.6775 5.84827 9.9468 5.55931L10.9985 4.43492C11.541 3.85503 12.459 3.85503 13.0015 4.43492Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_79"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClariaBlackLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/claria-black-logo.b6c32f49e630fbd2135c736d199942cb.svg";